module.exports = __webpack_public_path__ + "img/close-blue.svg";